export { CompareCourse } from "./compare_course";
export { CompareUniversity } from "./compare_university";
